import { Stack, Title } from '@mantine/core'
import { createFileRoute } from '@tanstack/react-router'
import OrdersTable from 'components/orders/OrdersTable'

export const Route = createFileRoute('/_auth/orders/')({
  component: RouteComponent,
})

function RouteComponent() {
  return (
    <Stack gap="xl">
      <Title order={1}>Zamówienia</Title>
      <OrdersTable />
    </Stack>
  )
}
